import { motion } from 'framer-motion';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import '../components/Card/ProductCard';
import Loader from '../components/Loader';
import { getProductList } from '../redux/actions/productActions';
import { Meta } from '../components';
import AnchorScroll from '../ScreenComponents/HomeCompo/AnchorScroll';
import HomeMainHeader from '../ScreenComponents/HomeCompo/HomeMainHeader';
import OursChoice from '../ScreenComponents/HomeCompo/OursChoice';
import LatestArrival from '../ScreenComponents/HomeCompo/LatestArrival';
import PhotoGallery from '../ScreenComponents/HomeCompo/PhotoGallery';


const HomeScreen = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const keyword = params.keyword || '';
  // const [pageNumber, setPageNumber] = useState(1);
  // const [pages, setPages] = useState(1);
  const { /*products,*/ /*pages: totalPage,*/ loading } = useSelector(
    state => state.productList
  );
  const { success: productCreated } = useSelector(state => state.productCreate);

  useEffect(() => {
    dispatch(getProductList(keyword, /*pageNumber*/));
  }, [dispatch, productCreated, /*pageNumber,*/ keyword]);

  // useEffect(() => {
  //   if (!totalPage) {
  //     setPages(page => page);
  //   } else {
  //     setPages(totalPage);
  //   }
  // }, [totalPage]);

  // const pageHandler = page => {
  //   setPageNumber(Number(page.selected + 1));
  // };

  return (
    <motion.div exit={{ opacity: 0 }} initial='initial' animate='animate' className='bubu_home'>
      {loading && <Loader />}
      <Meta title={'Home __bubu Shopkpr'} />
      <AnchorScroll />
      <div>
        <section id="one" className="scroll_common_section">
          <HomeMainHeader />
        </section>
        <section id="tow" className="scroll_common_section">
          <OursChoice />
          <LatestArrival />
        </section>
        <section id="three" className="scroll_common_section">
          <PhotoGallery />
        </section>
      </div>
    </motion.div>
  );
};

export default HomeScreen;
